import { motion } from "framer-motion";
import { ENGINES } from "@/data/content";

const draw = { hidden: { pathLength: 0, opacity: 0 }, visible: (i) => ({ pathLength: 1, opacity: 1, transition: { delay: 0.4 + i * 0.15, duration: 1, ease: "easeInOut" } }) };
const pop = { hidden: { opacity: 0, scale: 0.9 }, visible: (i) => ({ opacity: 1, scale: 1, transition: { delay: i * 0.12, duration: 0.5, ease: [0.16, 1, 0.3, 1] } }) };

const nodes = [
  { x: 60, y: 40 }, { x: 300, y: 40 }, { x: 540, y: 40 },
  { x: 60, y: 300 }, { x: 300, y: 300 }, { x: 540, y: 300 },
];

const ArchDiagram = () => (
  <div data-testid="architecture-diagram" className="relative w-full overflow-hidden border border-white/10 bg-black p-4 sm:p-8">
    <div className="mb-4 flex items-center justify-between border-b border-white/10 pb-3">
      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">ais://platform/architecture</span>
      <div className="flex gap-1.5">
        <span className="h-2 w-2 rounded-full bg-zinc-700" />
        <span className="h-2 w-2 rounded-full bg-zinc-700" />
        <span className="h-2 w-2 rounded-full bg-cyan-400 pulse-node" />
      </div>
    </div>
    <motion.svg viewBox="0 0 760 420" className="w-full" initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }}>
      {/* connection lines from each engine to core */}
      {nodes.map((n, i) => (
        <motion.line key={i} x1={n.x + 80} y1={n.y + 40} x2={380} y2={210} stroke="rgba(0,229,255,0.35)" strokeWidth="1" className="dash-flow" variants={draw} custom={i} />
      ))}
      {/* core node */}
      <motion.g variants={pop} custom={0}>
        <rect x={310} y={175} width={140} height={70} fill="rgba(0,229,255,0.08)" stroke="#00E5FF" strokeWidth="1.5" />
        <text x={380} y={205} textAnchor="middle" fill="#00E5FF" fontFamily="JetBrains Mono, monospace" fontSize="13" fontWeight="600">AIS CORE</text>
        <text x={380} y={225} textAnchor="middle" fill="#71717a" fontFamily="JetBrains Mono, monospace" fontSize="9">orchestration layer</text>
      </motion.g>
      {/* engine nodes */}
      {ENGINES.map((e, i) => (
        <motion.g key={e.id} variants={pop} custom={i + 1}>
          <rect x={nodes[i].x} y={nodes[i].y} width={160} height={80} fill="rgba(10,10,10,0.9)" stroke="rgba(0,229,255,0.4)" strokeWidth="1" />
          <text x={nodes[i].x + 12} y={nodes[i].y + 24} fill="#52525B" fontFamily="JetBrains Mono, monospace" fontSize="9">{e.code}</text>
          <text x={nodes[i].x + 12} y={nodes[i].y + 46} fill="#F4F4F5" fontFamily="Quantico, sans-serif" fontSize="15" fontWeight="600">{e.name.toUpperCase()}</text>
          <text x={nodes[i].x + 12} y={nodes[i].y + 64} fill="#00E5FF" fontFamily="JetBrains Mono, monospace" fontSize="8">{e.spec}</text>
          <circle cx={nodes[i].x + 148} cy={nodes[i].y + 14} r={3} fill="#00E5FF" className="pulse-node" />
        </motion.g>
      ))}
      {/* trust layer bar */}
      <motion.g variants={pop} custom={7}>
        <rect x={60} y={385} width={640} height={30} fill="rgba(41,121,255,0.06)" stroke="rgba(41,121,255,0.5)" strokeWidth="1" strokeDasharray="4 4" />
        <text x={380} y={404} textAnchor="middle" fill="#2979FF" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="4">BLOCKCHAIN TRUST LAYER — VERIFY / ANCHOR / ATTEST</text>
      </motion.g>
      <motion.line x1={380} y1={245} x2={380} y2={385} stroke="rgba(41,121,255,0.5)" strokeWidth="1" className="dash-flow" variants={draw} custom={6} />
    </motion.svg>
  </div>
);

export default ArchDiagram;
